import React from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { getTenant, TENANTS } from 'src/utils/tenant';
import { EnablementHomePage } from 'src/pages/HomePage/EnablementHomePage';
import { LearningHomePage } from 'src/pages/HomePage/LearningHomePage';
import { ENABLEMENT_ACADEMY_IN_ALP_FF } from 'src/constants';

export const TenantAwareHomePage: React.FC = () => {
  const tenant = getTenant();
  const enablementAcademyEnabled = FeatureGates.checkGate(ENABLEMENT_ACADEMY_IN_ALP_FF);

  if (tenant === TENANTS.ENABLEMENT_ACADEMY && enablementAcademyEnabled) {
    return <EnablementHomePage />;
  }

  return <LearningHomePage />;
};
